import { useTranslation } from 'next-i18next';

import { PeriodicOperationsTable } from '@/modules/home/components/PageContent/Inputs/PeriodicOperations/Table';
import HomeCardWrapper from '@/modules/home/components/shared/CardWrapper';

import GrassWithHand from '~/images/shared/GrassWithHand.svg';

const LatestPeriodicOperations = () => {
  const { t } = useTranslation();

  return (
    <HomeCardWrapper
      icon={<GrassWithHand width='24' height='24' />}
      title={t('Latest Periodic Operations')}
    >
      <PeriodicOperationsTable />
    </HomeCardWrapper>
  );
};

export default LatestPeriodicOperations;
